// Disable noisy console logging in production builds
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // Preserve errors and warnings, silence info/debug/log
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
}

// Export empty object to make this a module
export {};

